import { Button } from '@pickupp/ui/core'
import { makeStyles } from '@pickupp/ui/styles'
import cx from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'

import Icon from '~/src/components/Icon'

import Link from '../Link'
import styles from './styles'

const useStyles = makeStyles(styles)

const LinkButton = (props) => {
  const classes = useStyles()
  const {
    to,
    target,
    children,
    className,
    variant,
    color,
    icon,
    buttonClassName,
    ...otherProps
  } = props

  return (
    <Link
      to={to}
      target={target}
      className={cx(classes.linkContainer, className)}
      {...otherProps}
    >
      <Button
        color={color}
        variant={variant}
        component="span"
        className={buttonClassName}
      >
        <span className={classes.textAlign}>
          {icon && (
            <Icon
              size="1rem"
              className={classes.icon}
              {...icon}
            />
          )}
          {children}
        </span>
      </Button>
    </Link>
  )
}

LinkButton.propTypes = {
  to: PropTypes.string.isRequired,
  target: PropTypes.array,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  buttonClassName: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  icon: PropTypes.object,
}

LinkButton.defaultProps = {
  className: null,
  buttonClassName: null,
  variant: 'contained',
  color: 'primary',
  target: null,
  icon: null,
}

export default LinkButton
